var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionRules(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1207_216069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50098 17C4.67364 17 4.00098 16.3273 4.00098 15.5C4.00098 15.268 4.05564 15.036 4.15964 14.8287L5.38364 12.3813C5.58964 11.97 5.90431 11.624 6.28831 11.382C6.10231 11.128 5.99964 10.82 5.99964 10.5V5.5C5.99964 4.67267 6.67298 4 7.49964 4H16.4996C17.327 4 17.9996 4.67267 17.9996 5.5V10.5C17.9996 11.3273 17.327 12 16.4996 12H7.61898C7.04698 12 6.53298 12.318 6.27764 12.8287L5.05364 15.276C5.01898 15.3453 5.00098 15.4227 5.00098 15.4993C5.00098 15.7753 5.22564 15.9993 5.50098 15.9993H8.99964C9.27564 15.9993 9.49964 16.2233 9.49964 16.4993C9.49964 16.7753 9.27564 17 8.99964 17H5.50098ZM7.49964 5C7.22431 5 6.99964 5.224 6.99964 5.5V10.5C6.99964 10.776 7.22364 11 7.49964 11H16.4996C16.7756 11 16.9996 10.776 16.9996 10.5V5.5C16.9996 5.224 16.7756 5 16.4996 5H7.49964Z",
    fill: "#FF884E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20C11.6727 20 11 19.3273 11 18.5V14.5C11 13.6727 11.6727 13 12.5 13H18.5C19.3273 13 20 13.6727 20 14.5V18.5C20 19.3273 19.3273 20 18.5 20H12.5ZM12 18.5C12 18.776 12.2247 19 12.5 19H18.5C18.776 19 19 18.776 19 18.5V16H12V18.5ZM19 15V14.5C19 14.224 18.776 14 18.5 14H12.5C12.2247 14 12 14.224 12 14.5V15H19Z",
    fill: "#FF884E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 18C16.2247 18 16 17.776 16 17.5C16 17.224 16.224 17 16.5 17H17.5C17.776 17 18 17.224 18 17.5C18 17.776 17.776 18 17.5 18H16.5Z",
    fill: "#FF884E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1207_216069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionRules);
export default __webpack_public_path__ + "static/media/transaction-rules.42390fbf.svg";
export { ForwardRef as ReactComponent };